import { createFileRoute } from '@tanstack/react-router';

import { FillScreen } from '@/components/Layout';
import { useGetAssignmentPolicy } from '@/routes/_staff/ids/-api';

import {
  LoadingSkeleton,
  RuleAndPolicyContent,
} from '../-components/RuleAndPolicy';

export const Route = createFileRoute(
  '/_staff/ids/group-id/$id/_$id/rule-and-policy/',
)({
  component: RuleAndPolicyPage,
});

function RuleAndPolicyPage() {
  const proxyUserId = Route.useParams().id;
  const { data, isPending } = useGetAssignmentPolicy(proxyUserId);

  if (isPending) {
    return (
      <FillScreen className="flex flex-col gap-7 p-10">
        <LoadingSkeleton />
      </FillScreen>
    );
  }

  // エラー時は空のルールを表示（APIエラーはReact Queryが自動リトライ）
  return (
    <FillScreen className="flex flex-col gap-7 p-10">
      <RuleAndPolicyContent policy={data ?? { rules: [] }} />
    </FillScreen>
  );
}
